import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getErrorMessage } from '../utils/errors';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    if (user.perfil === 'SUPER_ADMIN') {
      navigate('/tenants', { replace: true });
      return;
    }

    const tenants = user.tenants || [];
    if (tenants.length === 0) return;

    if (tenants.length > 1) {
      navigate('/selecionar-tenant', { replace: true });
      return;
    }

    const destino = user.perfil === 'MOTORISTA' ? '/solicitacoes' : '/dashboard';
    navigate(destino, { replace: true });
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const response = await login(email, senha);

      if (response.perfil === 'SUPER_ADMIN') {
        navigate('/tenants');
        return;
      }

      const tenants = response.tenants || [];
      if (tenants.length > 1) {
        navigate('/selecionar-tenant');
      } else if (tenants.length === 1) {
        const destino = response.perfil === 'MOTORISTA' ? '/solicitacoes' : '/dashboard';
        navigate(destino);
      } else {
        setErro('Usuário não está vinculado a nenhuma organização ativa');
      }
    } catch (error) {
      setErro(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container disableGutters maxWidth="sm">
      <Box sx={{ mt: 10 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src="/images/logomarca.png" alt="GFrotas" style={{ height: 120 }} />
          </Box>

          {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              label="Senha"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              margin="normal"
              required
              InputLabelProps={{ shrink: true }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 3 }}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>

            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Button onClick={() => navigate('/recuperar-senha')}>
                Esqueci minha senha
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
